import { useEffect, useLayoutEffect } from "react";
import { useStudentFilterContext } from "../../components/features/NewStudentFilter/useStudentFilterContext";
import { useFetchStudentTags } from "../../hooks/http/useFetchStudentTags";

type UseInitializeStudentTagsProps = {
  sectionId: string | null;
  enabled?: boolean;
};

// 生徒フィルター用に全生徒タグを取得する
export const useInitializeStudentTags = ({
  sectionId,
  enabled = true,
}: UseInitializeStudentTagsProps) => {
  const context = useStudentFilterContext();

  // StudentFilterがsetFilterKeyをuseLayoutEffectで呼ぶのを想定している
  useLayoutEffect(() => {
    context.setFilterKey(sectionId);
  }, [sectionId, context.setFilterKey]);

  const queryEnabled = Boolean(sectionId) && enabled && !context.isTagLoaded;
  const query = useFetchStudentTags({
    sectionId: sectionId || "",
    activeStudent: true,
    enabled: queryEnabled,
  });

  useEffect(() => {
    if (!query.data) {
      return;
    }

    context.setFetchedAllStudentTags({ tags: query.data.tags });
  }, [query.data]);

  return query;
};

export default useInitializeStudentTags;
